import { Center, Loader } from '@mantine/core';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/stores/authContext';
import { useIsCarrier } from '@/hooks/useRoles';
import { ROUTES } from '@/routes/paths';

// Ограничение доступа: общая «Главная» /app (AppHome покупателя/продавца/агента) НЕ для перевозчика.
// Ставится только вокруг /app: перевозчик уводится в свой кабинет (по умолчанию /app/carrier), поэтому
// AppHome для него не рендерится и его покупательские/продавческие запросы не запускаются. Прочие
// торговые маршруты (/app/buy, /app/sell, ...) перевозчику в меню скрыты, но по URL достижимы —
// тождественно эталону RequireNonAgent (данные на бэкенде разграничены по личности).
export default function RequireNonCarrier({ redirectTo = ROUTES.APP_CARRIER }: { readonly redirectTo?: string }) {
  const { isInitializing } = useAuth();
  const isCarrier = useIsCarrier();

  if (isInitializing) {
    return (
      <Center h="50vh">
        <Loader />
      </Center>
    );
  }
  return isCarrier ? <Navigate to={redirectTo} replace /> : <Outlet />;
}
